module.exports = __webpack_public_path__ + "/login_ui/img/ps-1d76b77bf600f5acc337aad3a9614a82.svg";